<template>
  <div :class="`d-flex justify-content-between ${classes}`">
    <span class="d-flex gap-5px">
      <span v-if="icon" v-html="icon" style="margin-top: -2px"></span>
      <span>{{ label }}</span>
      <span
        v-if="info"
        v-html="svg_info"
        v-b-popover.hover.top="info"
        style="margin-top: -2px"
      ></span>
    </span>
    <span>
      <slot name="content"></slot>
      <span v-if="!$slots.content">
        {{ parsed_content }}
      </span>
    </span>
  </div>
</template>

<script>
import { info } from '@/components/svg/common';
import { currency } from '@/utilities';

export default {
  name: 'sidebar-row',
  props: {
    label: String,
    content: Number,
    icon: {
      type: String,
      default: () => '',
    },
    currency_verbose: {
      type: String,
      default: () => '',
    },
    classes: {
      type: String,
      default: () => '',
    },
    info: {
      type: String,
      default: () => '',
    },
  },
  computed: {
    parsed_content() {
      if (this.$slots.content) {
        return '';
      }
      if (this.currency_verbose) {
        return `${this.currency(this.currency_verbose)} ${this.content.toFixed(2)}`;
      }
      return this.content;
    },
  },
  data() {
    return {
      svg_info: info,
    };
  },
  methods: {
    currency,
  },
};
</script>

<style lang="scss" scoped></style>
